import React from "react";

import { Row, Column } from "components/Layout/Grid";

import DateOutput from "utils/DateOutput";
import { GetDaysFromSeconds, GetSecondsBetweenDates } from "utils/TimeOutput";

import {
  Trigger,
  Tooltip
} from "pipestyle";

interface IProps {
  history: any;
}

const CurrentPhaseHistory: React.FC<IProps> = (props) => {
const { history } = props;

  return (
    <Row
      className="w-100 bg-white mb-2 align-center justify-between"
      style={{
        height: 93.46,
        borderRadius: 3,
        padding: "24px 24px 24px 30px",
        paddingRight: 0,
        boxShadow: "0 1px 3px 0 rgba(192,208,230,.8)",
      }}
    >
      <Column className="pr-3">
        <h3 className="font-bold">{history.phase.name}</h3>
        <span
          className="pp-title-description font-light mt-1"
          style={{ fontSize: 12 }}
        >
          {GetDaysFromSeconds(GetSecondsBetweenDates(new Date().toString(), history.lastTimeIn))} nessa fase
        </span>
      </Column>
      <Row className="pr-2 align-center">
        <Column>
          <h3 className="font-bold text-right">
            <DateOutput dateStr={history.lastTimeIn} patternStr="dd/MM" />
          </h3>
          <span
            className="pp-title-description font-light text-right mt-1"
            style={{ fontSize: 12 }}
          >
            <DateOutput
              dateStr={history.lastTimeIn}
              patternStr="H:mm a"
            />
          </span>
        </Column>
        <Trigger
          className="ml-3"
          trigger="hover"
          placement="left"
          element={<Tooltip>Você está nessa fase</Tooltip>}
        >
          <div className="current-phase">
            <span />
          </div>
        </Trigger>
      </Row>
    </Row>
  );
}

export default CurrentPhaseHistory;